import { Button, type MantineStyleProp, Tooltip } from "@mantine/core";

export const ButtonCheckboxV1 = ({
  children,
  isActive,
  onClick,
  align,
  id,
  style = {},
  error,
  description,
}: {
  children: React.ReactNode;
  isActive: boolean;
  onClick: () => void;
  align?: "left" | "center" | "right";
  id: string;
  style?: MantineStyleProp;
  error?: string;
  description?: string;
}) => {
  const justify =
    align === "center"
      ? "center"
      : align === "left"
        ? "flex-start"
        : "flex-end";

  return (
    <Tooltip label={description} position="bottom" disabled={!description}>
      <Button
        onClick={onClick}
        data-testid={`button-select-${id}`}
        variant="light"
        color={isActive ? "blue" : "gray"}
        p="xs"
        m="5px"
        justify={justify}
        aria-pressed={isActive}
        style={() => ({
          borderColor: error ? "red" : undefined,
          textAlign: align,
          ...(isActive ? { border: "2px solid #228be6" } : {}),
          ...style,
        })}
      >
        {children}
      </Button>
    </Tooltip>
  );
};
